import React, { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
// import QuotePopup from  '../QuotePopup'
import ArrowDownIcon from "../Icons/ArrowDownIcon"
import SaleBg from "../../images/sale/salebg.jpg"
import MobileSaleBg from "../../images/sale/mobile-salebg.jpg"
import SaleOfferGif from "../../images/sale/offer.gif"
import SaleOfferMobileGif from "../../images/sale/offer-mobile.gif"

const SaleLocation = styled.div`
  position: relative;
`
const SaleWrap = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  max-width: 100%;
  width: 100%;
  transition: all 0.5s;
  transform: translateY(100%);
  box-shadow: 0px -2px 20px rgba(0, 0, 0, 0.4);
  background-color: #fff;
  background-image: ${props => props.mbg};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 100%;
  @media (min-width: 992px) {
    background-image: ${props => props.bg};
    background-position: 0 100%;
  }
  @media (min-width: 1200px) {
    background-position: 25% 100%;
  }
  @media (min-width: 1600px) {
    background-position: 50% 100%;
  }
  &.show {
    transform: translateY(0);
    .arrow {
      svg {
        transform: scaleY(1);
      }
    }
  }
`

const SaleArrow = styled.div`
  position: absolute;
  right: 15px;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: calc(100% - 1px);
  z-index: 4;
  width: 38px;
  height: 38px;
  background: #00061e;
  border-radius: 10px 10px 0 0;
  svg {
    fill: #fff;
    transform: scaleY(-1);
    transition: all 0.4s ease-in-out;
    height: 12px;
    width: 12px;
  }
`

const SaleContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
`
const SaleInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 80px;
  @media (min-width: 992px) {
    min-height: 100px;
  }
  @media (min-width: 1600px) {
    min-height: 100px;
  }
`

const SaleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-wrap: nowrap;
  width: 100%;
  margin: 0 -5px;
  padding: 5px 10px;
  @media (min-width: 768px) {
    padding: 0 10px;
  }
  @media (min-width: 992px) {
    max-width: 920px;
    margin: 0 -15px;
  }
  @media (min-width: 1200px) {
    max-width: 100%;
    margin: 0 -20px;
  }
  @media (min-width: 1400px) {
    margin: 0 -30px;
  }
  @media (min-width: 1600px) {
    margin: 0 -40px;
  }
`
const SaleColumn = styled.div`
  padding: 0 10px;
  @media (min-width: 992px) {
    padding: 0 15px;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 40px;
  }
`

//CSS for Desktop
const SaleForDesktop = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
const SaleTitle = styled.div`
  @media (min-width: 768px) {
    padding: 0 15px;
  }
  @media (min-width: 992px) {
    padding: 0 20px;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 40px;
  }
`
const SaleOffter = styled.div`
  @media (min-width: 768px) {
    padding: 0 15px;
  }
  @media (min-width: 992px) {
    padding: 0 20px;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1400px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 40px;
  }
`
const CallText = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  color: #fff;
  max-width: 170px;
  width: 100%;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 26px;
  }
  @media (min-width: 1600px) {
    font-size: 22px;
    line-height: 28px;
  }
`
const SaleHelpText = styled.div`
  white-space: nowrap;
  color: #fff;
  text-align: center;
  letter-spacing: 0.5px;
  margin-top: 0;
  letter-spacing: 0.1px;
  font-size: 9px;
  line-height: 14px;
  @media (min-width: 992px) {
    font-size: 11px;
    line-height: 16px;
  }
  @media (min-width: 1200px) {
    font-size: 12px;
  }
`

const ButtonToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
  @media (min-width: 576px) {
    margin: 0 auto 10px;
  }
  .btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    white-space: nowrap;
    border-radius: 10px;

    > .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: -15px;
      background-color: #ffdf00;

      min-width: 26px;
      min-height: 26px;
      border-radius: 8px;
      @media (min-width: 576px) {
        min-width: 32px;
        min-height: 32px;
      }
      @media (min-width: 992px) {
        left: -25px;

        min-width: 38px;
        min-height: 38px;
      }
      @media (min-width: 1200px) {
        min-width: 44px;
        min-height: 44px;
      }
      @media (min-width: 1600px) {
        min-width: 50px;
        min-height: 50px;
      }
      .gatsby-image-wrapper {
        width: 18px;
        @media (min-width: 576px) {
          width: auto;
        }
      }
    }
    > .text {
      background-color: #ff1717;
      color: #fff;
      border-radius: 8px;
      font-size: 14px;
      line-height: 20px;
      min-height: 20px;
      font-weight: 700;
      padding: 3px 10px 3px 25px;
      @media (min-width: 576px) {
        font-size: 16px;
        line-height: 24px;
        min-height: 24px;
        padding: 4px 15px 4px 30px;
      }
      @media (min-width: 992px) {
        font-size: 18px;
        line-height: 24px;
        min-height: 24px;
        padding: 7px 20px 7px 35px;
      }
      @media (min-width: 1200px) {
        font-size: 20px;
        line-height: 26px;
        min-height: 26px;
        padding: 8px 20px 8px 40px;
      }
      @media (min-width: 1600px) {
        font-size: 24px;
        line-height: 28px;
        min-height: 28px;
        padding: 10px 24px 10px 48px;
      }
    }
  }
  .btn-red {
    background-color: #ff1717;
    border-color: #ff1717;
    color: #fff;
  }
  &.d-md-none {
    @media (min-width: 768px) {
      display: none;
    }
  }
  &.d-md-block {
    display: none;
    @media (min-width: 768px) {
      display: flex;
    }
  }
`

//CSS for Mobile
const SaleForMobile = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 768px) {
    display: none;
  }
`
const SaleTitleMobile = styled.div`
  margin: 0 auto 5px auto;
  .gatsby-image-wrapper {
    max-width: 150px;
    @media (min-width: 576px) {
      max-width: 170px;
    }
    width: 100 %;
    margin: 0 auto;
  }
`
const SaleOffterMobile = styled.div`
margin - bottom: 5px;
max - width: 200px;
display: flex;
@media(min - width: 768px) {
  display: none;
}
`

const SaleBlackFriday = ({ location }) => {
  const [showHelp, setShowHelp] = useState(true);
  const prevScrollPosRef = useRef(0);
  const stickyClosedRef = useRef("");

  const ToggleHelp = () => {
    stickyClosedRef.current = !showHelp ? "closed" : "";
    const res = showHelp ? "show" : "hide";
    localStorage.setItem("SaleBlackFriday", res);
    setShowHelp(!showHelp);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = document.documentElement.scrollTop;

      if (currentScrollPos > prevScrollPosRef.current) {
        setShowHelp(true);
      } else if (
        currentScrollPos === 0 &&
        stickyClosedRef.current !== "closed"
      ) {
        setShowHelp(false);
      }

      prevScrollPosRef.current = currentScrollPos;
    };

    if (typeof window !== `undefined`) {
      const cd = localStorage.getItem("SaleBlackFriday");
      if (!cd || cd === "show") {
        setShowHelp(false);
        stickyClosedRef.current = ""
      } else {
        setShowHelp(true);
        stickyClosedRef.current = "closed"
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <SaleLocation location={location}>
      <SaleWrap
        className={showHelp ? "" : "show"}
        bg={`url(${SaleBg})`}
        mbg={`url(${MobileSaleBg})`}
      >
        <SaleArrow className="arrow" onClick={ToggleHelp}>
          <ArrowDownIcon />
        </SaleArrow>
        <SaleContainer>
          <SaleInner>
            <SaleRow>
              <SaleColumn>
                {/* Desktop */}
                <SaleForDesktop>
                  <SaleTitle>
                    <StaticImage
                      src="../../images/sale/sale-title.png"
                      placeholder="blurred"
                      alt="Coast to Coast Carports"
                    />
                  </SaleTitle>
                  <SaleOffter>
                    <img src={SaleOfferGif} alt="Coast to Coast Carports" />
                  </SaleOffter>
                  <CallText>Call Now To Get Your Best Offer</CallText>
                </SaleForDesktop>

                {/* Mobile */}
                <SaleForMobile>
                  <SaleTitleMobile>
                    <StaticImage
                      src="../../images/sale/sale-title-mobile.png"
                      placeholder="blurred"
                      alt="Coast to Coast Carports"
                    />
                  </SaleTitleMobile>
                  <ButtonToolbar className="d-md-none">
                    <a
                      href="tel:8666817846"
                      aria-label="phone number"
                      className="btn btn-red"
                    >
                      <span className="icon">
                        {" "}
                        <StaticImage
                          src="../../images/sale/call.png"
                          placeholder="blurred"
                          alt="Coast to Coast Carports"
                        />
                      </span>
                      <span className="text">(866) 681-7846</span>
                    </a>
                  </ButtonToolbar>
                </SaleForMobile>
              </SaleColumn>

              <SaleColumn>
                <SaleOffterMobile>
                  <img src={SaleOfferMobileGif} alt="Coast to Coast Carports" />
                </SaleOffterMobile>
                <ButtonToolbar className="d-md-block">
                  <a
                    href="tel:8666817846"
                    aria-label="phone number"
                    className="btn btn-red"
                  >
                    <span className="icon">
                      {" "}
                      <StaticImage
                        src="../../images/sale/call.png"
                        placeholder="blurred"
                        alt="Coast to Coast Carports"
                      />
                    </span>
                    <span className="text">(866) 681-7846</span>
                  </a>
                </ButtonToolbar>
                <SaleHelpText>*Offer Valid in Select States Only!</SaleHelpText>
              </SaleColumn>
            </SaleRow>
          </SaleInner>
        </SaleContainer>
      </SaleWrap>
    </SaleLocation>
  )
}
export default SaleBlackFriday
